export type PantryState = {
  itemCount:               number
  outCount:                number
  expiringSoonCount:       number
  lastShopConfirmedAt?:    Date
  hasMealPlannedForToday?: boolean
}

export function getWelcomeLine(state: PantryState, now = new Date()): string {
  if (state.itemCount === 0) {
    return "Let's get your kitchen mapped."
  }

  if (state.outCount >= 1) {
    return "A few things need your attention today."
  }

  if (state.expiringSoonCount >= 3) {
    return "Let's use what's ripening before it turns."
  }

  if (state.lastShopConfirmedAt) {
    const hoursAgo = (now.getTime() - state.lastShopConfirmedAt.getTime()) / 3_600_000
    if (hoursAgo < 24) {
      return "Fresh haul. Here's what came home."
    }
  }

  if (state.hasMealPlannedForToday) {
    return "Something good is planned for tonight."
  }

  if (state.outCount === 0 && state.expiringSoonCount === 0) {
    return "The pantry's in good shape."
  }

  return "Welcome to your pantry."
}
